import React from 'react';
import styled from 'styled-components';
import {
  useCohortRowContext,
  useCohortRowOperatorAndValues,
} from '../CohortRowContext';
import CohortRowOperatorValue from './CohortRowOperatorValue';
import * as BuilderUI from '../../../BuilderUI';

const BetweenMark = styled(BuilderUI.BuilderFieldLabel)`
  margin-top: 6px;
  margin-right: 0;
`;

const CohortRowBetweenOperatorValues = () => {
  const { rowMeta, cohortRow } = useCohortRowContext();
  const { simpleCohortTypeKey } = cohortRow;
  const { operatorValues = [] } = useCohortRowOperatorAndValues();
  return (
    <>
      <CohortRowOperatorValue
        simpleCohortTypeKey={simpleCohortTypeKey}
        value={operatorValues?.[0] ?? null}
        rowMeta={{
          ...rowMeta,
          numberIndex: 0,
        }}
      />
      <BetweenMark>~</BetweenMark>
      <CohortRowOperatorValue
        simpleCohortTypeKey={simpleCohortTypeKey}
        value={operatorValues?.[1] ?? null}
        rowMeta={{
          ...rowMeta,
          numberIndex: 1,
        }}
      />
    </>
  );
};

export default CohortRowBetweenOperatorValues;
